import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=a8f72090&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=a8f72090&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f72090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8f72090')) {
      api.createRecord('a8f72090', component.options)
    } else {
      api.reload('a8f72090', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=a8f72090&scoped=true", function () {
      api.rerender('a8f72090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Informational/PrivacyPolicy.vue"
export default component.exports